export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-200">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-fill text-background-50 text-lg"></i>
              </div>
              <span className="font-heading font-bold text-base text-background-50 whitespace-nowrap">
                91麻豆免费视频网站
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              综合性在线视频平台，汇聚91年国产影片视频、91传媒视频在线、91精彩视频在线观看等丰富频道，影视网站免费观看热门影视在线。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-bold text-sm text-background-100 mb-4">快速导航</h4>
            <div className="space-y-2">
              <a href="#carousel" className="block text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">焦点专题</a>
              <a href="#ranking" className="block text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">热门排行</a>
              <a href="#media" className="block text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">精彩视频</a>
              <a href="#cards" className="block text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">精选推荐</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-bold text-sm text-background-100 mb-4">频道导航</h4>
            <div className="space-y-2">
              <a href="#index" className="block text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">91国产影片专区</a>
              <a href="#carousel" className="block text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">91传媒原创频道</a>
              <a href="#media" className="block text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">热门影视在线</a>
              <a href="#app" className="block text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">APP下载</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-bold text-sm text-background-100 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-400 leading-relaxed">
              携手优质内容伙伴，共同打造丰富的影视生态。如有合作意向，欢迎联系我们。
            </p>
          </div>
        </div>

        <div className="mt-10 md:mt-12 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 91麻豆免费视频网站 · 综合性在线视频平台
          </p>
          <div className="flex items-center gap-4">
            <a href="#faq" className="text-xs text-background-500 hover:text-primary-400 transition-colors cursor-pointer">常见问题</a>
            <a href="#about" className="text-xs text-background-500 hover:text-primary-400 transition-colors cursor-pointer">关于我们</a>
            <a href="#contact" className="text-xs text-background-500 hover:text-primary-400 transition-colors cursor-pointer">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}